import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewUnavailableState = {
	url: '/unavailable/:customerToken/:serviceProviderId/:consultationId/:proposalId',
	title: 'View Unavailable Proposal',
	params: {customerToken: null, serviceProviderId: null, consultationId: null, proposalId: null},
	// One state, one URL: the v2 provider flag decides which component renders. This state is
	// in publicStates, so getPresentationFlags reads the flag from the customer endpoint,
	// which needs the customerToken, serviceProviderId and consultationId already in the URL.
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-unavailable-v2></view-unavailable-v2>'
				: '<view-unavailable></view-unavailable>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "viewUnavailableV2Mod" */
								'@Containers/view-unavailable-page/view-unavailable-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "unavailablePageMod" */
								'@Containers/view-unavailable-page/view-unavailable.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$', '$log'],
			// Swallowed rather than allowed to fail the transition, as on view.expired: this
			// state is where customers land when their consultation is unreachable, so it must
			// not itself depend on a flag lookup succeeding. An empty payload renders v1.
			resolveFn: (RoutesSvc, trans, $log) =>
				RoutesSvc.getPresentationFlags({trans}).catch(err => {
					$log.error('view.unavailable provider flags failed, falling back to v1:', err);
					return {};
				}),
		},
	],
};
